const PERSISTABLE_GRID_STATE_KEYS = new Set([
    'active-view',
    'claim-params',
    'header-search',
    'historyQuery',
    'leaderboard-params',
    'lodgement-links',
    'query-params',
    'query-variables',
    'record-query-params',
    'queryParams',
    'queryVariables',
    'sg-messages-query',
    'sg-messages-query-v2',
    'sg-event-filters-v2',
    'workload-my-work',
    'workload-query-params',
]);

/**
 * Grid path state is identified by the leaf key used by `usePathState`. Keep this matcher
 * exported so the source-inventory regression test can prove every path-backed Prisma table
 * query is covered when a caller introduces a new key.
 */
export function isPersistableGridStateKey(key: string): boolean {
    if (!key.startsWith('pathState:')) return false;

    const stateKey = key.slice(key.lastIndexOf(':') + 1);
    return (
        PERSISTABLE_GRID_STATE_KEYS.has(stateKey) ||
        stateKey.endsWith('-filters') ||
        stateKey.endsWith('-filters-where') ||
        stateKey.startsWith('history-query-')
    );
}
